import e from"../load-plugins.js";import t from"vue";import r from"./mixins.js";import{defineProp as p}from"./props.js";import o from"./base.js";import{withVisible as m,withZIndex as s,withOpacity as i,withZooms as a}from"./common.js";var n=r(o,m(!0),s,i,a).extend({amapMeta:{prepare:function(){return e("AMap.DistrictLayer")},events:["complete"]},props:{styles:p({type:Object,setter:"setStyles"})}}),f=t.extend({props:{depth:{type:Number}}});export default n;export{f as withDepth};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amap/amap-vue/es/mixins/district-layer.js
// module id = null
// module chunks = 